var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush, getEhashCookie, getSupporterID } from "../shared/utils";
function handleFeedCardView(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var msc_card_type = eventData.msc_card_type, msc_card_title = eventData.msc_card_title;
    var ehash = getEhashCookie();
    var supporter_id = getSupporterID();
    var messageViewData = normalizeObject(__assign(__assign({ "event_action": "msc_feed_card_impression" }, eventData), { "event": "feed_card_view", "event_category": "".concat(msc_card_type, "_view"), "event_label": msc_card_title, non_interaction: true, ehash: ehash, supporter_id: supporter_id }));
    dataLayerPush(messageViewData);
}
function handleFeedCardClick(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var msc_card_type = eventData.msc_card_type, msc_card_title = eventData.msc_card_title, click_text = eventData.click_text;
    var ehash = getEhashCookie();
    var supporter_id = getSupporterID();
    var messageViewData = normalizeObject(__assign(__assign({ "event_action": "msc_feed_card_click" }, eventData), { "event": "feed_card_click", "event_category": "".concat(msc_card_type, "_").concat(click_text), "event_label": msc_card_title, non_interaction: false, ehash: ehash, supporter_id: supporter_id, retain_interactions: 1, ret_my_sponsored_child_interactions: 1 }));
    dataLayerPush(messageViewData);
}
export { handleFeedCardView, handleFeedCardClick };
